import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { PublicHolidayModel } from "../models/PublicHolidayModels/PublicHolidayModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";

@Injectable({
  providedIn: 'root'
})
export class PublicHolidayService {
  ApiUrl = "/api/admin/PublicHoliday/"

  constructor(private http: RequestHandlerService) { }

  AddPublicHoliday(AddModel: PublicHolidayModel) {
    
    return this.http.post( this.ApiUrl + 'AddPublicHoliday', AddModel);
  }
  EditPublicHoliday( EditModel: PublicHolidayModel) {
   
    return this.http.post( this.ApiUrl + 'EditPublicHoliday', EditModel);
  }
  DeletePublicHoliday( UsersIDRequestModel: UsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'DeletePublicHoliday', UsersIDRequestModel);
  }

  GenerateUAEPublicHoliday() {
   
    return this.http.get( this.ApiUrl + 'GenerateUAEPublicHoliday',);
  }

  Loaddropdowns() {
    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
}

